import { eventCategory } from "@foretagsplatsen/yaem";
import { homeIcon } from "../../../core/elements/icons/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import BreadCrumbsWidget from "../../../core/widgets/BreadCrumbsWidget.js";
import ListAndIconViewSwitch from "../../../core/widgets/ListAndIconViewSwitch/ListAndIconViewSwitch.js";

/**
 * `documentArchiveBreadCrumbsWidget` displays a `breadCrumbsWidget`
 * specialized for the document archive. Beyond showing the path to
 * the current folder, the receiver can show an optional list of
 * actions on the right-hand side. After the list of actions, the
 * receiver always shows a switch between list view and iconic view.
 *
 * @param {Renderable[]} [spec.actions] - Renderables added at
 * the right-side of the breadcrumb and before the list view switcher.
 * @param {predicate} spec.isIconicView - This function should return
 * true iff the current active view is the iconic one.
 */
export default class DocumentArchiveBreadCrumbsWidget extends Widget {
	constructor({ actions = [], isIconicView }) {
		super(...arguments);

		this._actions = actions;
		this._isIconicView = isIconicView;

		this._eventHandler = eventCategory();

		this.onSetListView = this._eventHandler.createEvent("setListView");
		this.onSetIconicView = this._eventHandler.createEvent("setIconicView");

		this._breadCrumbsWidget = new BreadCrumbsWidget({
			getLabel: (entry) => {
				if (entry.isRoot()) {
					return homeIcon;
				}
				return entry.name();
			},
			cssClass: "nopadding col-xs-12 col-sm-4 col-md-4 col-lg-6",
		});

		this._switcher = new ListAndIconViewSwitch({
			onListView: this._setListView.bind(this),
			onWidgetView: this._setIconicView.bind(this),
			isDefaultViewActive: this._isIconicView,
		});
	}

	onClick(callback) {
		this._breadCrumbsWidget.onClick(callback);
	}

	setCurrentFolder(folder) {
		this._breadCrumbsWidget.setItems(folder.getFullPath());
	}

	renderContentOn(html) {
		html.div(
			{ klass: "row" },
			html.div(
				{ klass: "col-lg-12" },
				html.div(
					{ klass: "document-archive-row clearfix" },
					this._breadCrumbsWidget,
					this.renderActionsOn.bind(this),
				),
			),
		);
	}

	renderActionsOn(html) {
		html.div(
			{ klass: "col-xs-12 col-sm-8 col-md-8 col-lg-6 nopadding" },
			html.div(
				{ klass: "actions-breadcrumbs" },
				this._actions,
				this._switcher,
			),
		);
	}

	_setListView() {
		this._eventHandler.trigger("setListView");
	}

	_setIconicView() {
		this._eventHandler.trigger("setIconicView");
	}
}
